export default {
  metadata: {
    version: '2.0.0',
    id: 'badge-information-2.0.0',
    name: 'JDSBadgeV2Information'
  },
  hierarchy: {
    container: [
      {
        'inner-container': [
          {
            'image-container': ['jds_image']
          },
          {
            'icon-container': ['icon']
          },
          'label-jds-text'
        ]
      }
    ]
  },
  base: {
    container: {
      'border-radius': '{b_0}'
    },
    'inner-container': {
      'flex-direction': '{b_2}',
      'justify-content': '{b_3}',
      'align-items': '{b_4}',
      'background-color': '{b_5}',
      gap: '{b_6}',
      'border-radius': '{b_7}',
      'padding-left': '{b_8}',
      'padding-right': '{b_9}',
      'padding-top': '{b_10}',
      'padding-bottom': '{b_11}'
    },
    'icon-container': {
      hidden: false,
      show: true,
      'flex-direction': '{b_12}',
      'justify-content': '{b_13}',
      'align-items': '{b_14}',
      size: '{b_15}'
    },
    icon: {
      color: '{b_16}',
      size: '{b_17}'
    },
    'image-container': {
      hidden: true,
      show: true,
      'flex-direction': '{b_18}',
      'justify-content': '{b_19}',
      'align-items': '{b_20}',
      size: '{b_21}',
      overflow: 'hidden'
    },
    jds_image: {
      aspectRatio: 'round'
    },
    'label-jds-text': {
      'font-family': '{text_152}',
      color: '{text_19}',
      'font-size': '{text_151}',
      'line-height': '{text_153}',
      'letter-spacing': '{text_154}',
      'font-weight': '{text_155}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false
    }
  },
  variant: {
    kind: {
      label: {
        'icon-container': {
          hidden: true
        }
      },
      'label-image': {
        'icon-container': {
          hidden: true
        },
        'image-container': {
          hidden: false
        }
      },
      icon: {
        'label-jds-text': {
          hidden: true
        }
      },
      'icon-circle': {
        'label-jds-text': {
          hidden: true
        }
      },
      'icon-square': {
        'label-jds-text': {
          hidden: true
        }
      }
    },
    size: {
      'xtra-small': {
        'inner-container': {
          'padding-right': '{b_25}',
          'padding-top': '{b_26}',
          'padding-bottom': '{b_27}'
        },
        'icon-container': {
          size: '{b_28}'
        },
        icon: {
          size: '{b_29}'
        },
        'image-container': {
          size: '{b_30}'
        },
        'label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      small: {
        'inner-container': {
          'padding-right': '{b_31}',
          'padding-top': '{b_32}',
          'padding-bottom': '{b_33}'
        },
        'icon-container': {
          size: '{b_34}'
        },
        icon: {
          size: '{b_35}'
        },
        'image-container': {
          size: '{b_36}'
        },
        'label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      medium: {
        'inner-container': {
          'padding-right': '{b_37}',
          'padding-top': '{b_38}',
          'padding-bottom': '{b_39}'
        },
        'icon-container': {
          size: '{b_40}'
        },
        icon: {
          size: '{b_41}'
        },
        'image-container': {
          size: '{b_42}'
        },
        'label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      large: {
        'label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      'xtra-xtra-large': {
        'inner-container': {
          'padding-left': '{b_43}',
          'padding-top': '{b_44}',
          'padding-bottom': '{b_45}'
        }
      },
      'xtra-xtra-xtra-large': {
        container: {
          'border-radius': '{b_46}'
        },
        'inner-container': {
          'border-radius': '{b_47}',
          'padding-left': '{b_48}',
          'padding-top': '{b_49}',
          'padding-bottom': '{b_50}'
        },
        'icon-container': {
          size: '{b_51}'
        },
        icon: {
          size: '{b_52}'
        },
        'image-container': {
          size: '{b_53}'
        },
        'label-jds-text': {
          'font-family': '{text_137}',
          'font-size': '{text_136}',
          'line-height': '{text_138}',
          'letter-spacing': '{text_139}',
          'font-weight': '{text_140}'
        }
      },
      'xtra-xtra-xtra-xtra-large': {
        container: {
          'border-radius': '{b_54}'
        },
        'inner-container': {
          'border-radius': '{b_55}',
          'padding-left': '{b_56}',
          'padding-right': '{b_57}',
          'padding-top': '{b_58}',
          'padding-bottom': '{b_59}'
        },
        'icon-container': {
          size: '{b_60}'
        },
        icon: {
          size: '{b_61}'
        },
        'image-container': {
          size: '{b_62}'
        },
        'label-jds-text': {
          'font-family': '{text_107}',
          'font-size': '{text_106}',
          'line-height': '{text_108}',
          'letter-spacing': '{text_109}',
          'font-weight': '{text_110}'
        }
      }
    },
    color: {
      secondary: {
        'inner-container': {
          'background-color': '{b_22}'
        },
        'icon-container': {
          'background-color': '{b_23}'
        },
        icon: {
          color: '{b_24}'
        }
      },
      positive: {
        'inner-container': {
          'background-color': '{b_63}'
        },
        'icon-container': {
          'background-color': '{b_64}'
        }
      },
      warning: {
        'inner-container': {
          'background-color': '{b_65}'
        },
        'icon-container': {
          'background-color': '{b_66}'
        }
      },
      negative: {
        'inner-container': {
          'background-color': '{b_67}'
        },
        'icon-container': {
          'background-color': '{b_68}'
        }
      },
      neutral: {
        'inner-container': {
          'background-color': '{b_69}'
        },
        'icon-container': {
          'background-color': '{b_70}'
        }
      }
    },
    border: {
      true: {
        container: {
          'background-color': '{b_72}',
          'padding-top': '{b_71}',
          'padding-bottom': '{b_71}',
          'padding-left': '{b_71}',
          'padding-right': '{b_71}'
        }
      }
    }
  },
  combination: [
    {
      icon: {
        'xtra-small': {
          'inner-container': {
            'padding-left': '{b_73}',
            'padding-right': '{b_73}',
            'padding-top': '{b_73}',
            'padding-bottom': '{b_73}'
          },
          'icon-container': {
            size: '{b_74}'
          },
          icon: {
            size: '{b_75}'
          }
        },
        small: {
          'inner-container': {
            'padding-left': '{b_76}',
            'padding-right': '{b_76}',
            'padding-top': '{b_76}',
            'padding-bottom': '{b_76}'
          },
          'icon-container': {
            size: '{b_77}'
          },
          icon: {
            size: '{b_78}'
          }
        },
        medium: {
          'inner-container': {
            'padding-left': '{b_79}',
            'padding-right': '{b_79}',
            'padding-top': '{b_79}',
            'padding-bottom': '{b_79}'
          },
          'icon-container': {
            size: '{b_80}'
          },
          icon: {
            size: '{b_81}'
          }
        },
        large: {
          'inner-container': {
            'padding-left': '{b_82}',
            'padding-right': '{b_82}',
            'padding-top': '{b_82}',
            'padding-bottom': '{b_82}'
          },
          'icon-container': {
            size: '{b_87}'
          },
          icon: {
            size: '{b_88}'
          }
        },
        'xtra-large': {
          'inner-container': {
            'padding-left': '{b_83}',
            'padding-right': '{b_83}',
            'padding-top': '{b_83}',
            'padding-bottom': '{b_83}'
          },
          'icon-container': {
            size: '{b_89}'
          },
          icon: {
            size: '{b_90}'
          }
        },
        'xtra-xtra-large': {
          'inner-container': {
            'padding-left': '{b_84}',
            'padding-right': '{b_84}',
            'padding-top': '{b_84}',
            'padding-bottom': '{b_84}'
          },
          'icon-container': {
            size: '{b_91}'
          },
          icon: {
            size: '{b_92}'
          }
        },
        'xtra-xtra-xtra-large': {
          'inner-container': {
            'padding-left': '{b_85}',
            'padding-right': '{b_85}',
            'padding-top': '{b_85}',
            'padding-bottom': '{b_85}'
          },
          'icon-container': {
            size: '{b_93}'
          },
          icon: {
            size: '{b_94}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          'inner-container': {
            'padding-left': '{b_86}',
            'padding-right': '{b_86}',
            'padding-top': '{b_86}',
            'padding-bottom': '{b_86}'
          },
          'icon-container': {
            size: '{b_95}'
          },
          icon: {
            size: '{b_96}'
          }
        }
      },
      'icon-circle': {
        'xtra-small': {
          container: {
            'border-radius': '{b_97}'
          },
          'inner-container': {
            'border-radius': '{b_98}',
            'padding-left': '{b_99}',
            'padding-right': '{b_99}',
            'padding-top': '{b_99}',
            'padding-bottom': '{b_99}'
          },
          'icon-container': {
            size: '{b_100}',
            'border-radius': '{b_101}'
          },
          icon: {
            size: '{b_102}'
          }
        },
        small: {
          container: {
            'border-radius': '{b_103}'
          },
          'inner-container': {
            'border-radius': '{b_104}',
            'padding-left': '{b_105}',
            'padding-right': '{b_105}',
            'padding-top': '{b_105}',
            'padding-bottom': '{b_105}'
          },
          'icon-container': {
            size: '{b_106}',
            'border-radius': '{b_107}'
          },
          icon: {
            size: '{b_108}'
          }
        },
        medium: {
          container: {
            'border-radius': '{b_109}'
          },
          'inner-container': {
            'border-radius': '{b_109}',
            'padding-left': '{b_110}',
            'padding-right': '{b_110}',
            'padding-top': '{b_110}',
            'padding-bottom': '{b_110}'
          },
          'icon-container': {
            size: '{b_111}',
            'border-radius': '{b_112}'
          },
          icon: {
            size: '{b_113}'
          }
        },
        large: {
          container: {
            'border-radius': '{b_114}'
          },
          'inner-container': {
            'border-radius': '{b_114}',
            'padding-left': '{b_115}',
            'padding-right': '{b_115}',
            'padding-top': '{b_115}',
            'padding-bottom': '{b_115}'
          },
          'icon-container': {
            size: '{b_116}',
            'border-radius': '{b_117}'
          },
          icon: {
            size: '{b_118}'
          }
        },
        'xtra-large': {
          container: {
            'border-radius': '{b_119}'
          },
          'inner-container': {
            'border-radius': '{b_119}',
            'padding-left': '{b_120}',
            'padding-right': '{b_120}',
            'padding-top': '{b_120}',
            'padding-bottom': '{b_120}'
          },
          'icon-container': {
            size: '{b_121}',
            'border-radius': '{b_122}'
          },
          icon: {
            size: '{b_123}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'border-radius': '{b_124}'
          },
          'inner-container': {
            'border-radius': '{b_124}',
            'padding-left': '{b_125}',
            'padding-right': '{b_125}',
            'padding-top': '{b_125}',
            'padding-bottom': '{b_125}'
          },
          'icon-container': {
            size: '{b_126}',
            'border-radius': '{b_127}'
          },
          icon: {
            size: '{b_128}'
          }
        },
        'xtra-xtra-xtra-large': {
          container: {
            'border-radius': '{b_129}'
          },
          'inner-container': {
            'border-radius': '{b_129}',
            'padding-left': '{b_130}',
            'padding-right': '{b_130}',
            'padding-top': '{b_130}',
            'padding-bottom': '{b_130}'
          },
          'icon-container': {
            size: '{b_131}',
            'border-radius': '{b_132}'
          },
          icon: {
            size: '{b_133}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          container: {
            'border-radius': '{b_134}'
          },
          'inner-container': {
            'border-radius': '{b_134}',
            'padding-left': '{b_135}',
            'padding-right': '{b_135}',
            'padding-top': '{b_135}',
            'padding-bottom': '{b_135}'
          },
          'icon-container': {
            size: '{b_136}',
            'border-radius': '{b_137}'
          },
          icon: {
            size: '{b_138}'
          }
        }
      },
      'icon-square': {
        'xtra-small': {
          container: {
            'border-radius': '{b_139}'
          },
          'inner-container': {
            'border-radius': '{b_140}',
            'padding-left': '{b_141}',
            'padding-right': '{b_141}',
            'padding-top': '{b_141}',
            'padding-bottom': '{b_141}'
          },
          'icon-container': {
            size: '{b_142}',
            'border-radius': '{b_143}'
          },
          icon: {
            size: '{b_144}'
          }
        },
        small: {
          container: {
            'border-radius': '{b_145}'
          },
          'inner-container': {
            'border-radius': '{b_145}',
            'padding-left': '{b_146}',
            'padding-right': '{b_146}',
            'padding-top': '{b_146}',
            'padding-bottom': '{b_146}'
          },
          'icon-container': {
            size: '{b_147}',
            'border-radius': '{b_148}'
          },
          icon: {
            size: '{b_149}'
          }
        },
        medium: {
          container: {
            'border-radius': '{b_150}'
          },
          'inner-container': {
            'border-radius': '{b_150}',
            'padding-left': '{b_151}',
            'padding-right': '{b_151}',
            'padding-top': '{b_151}',
            'padding-bottom': '{b_151}'
          },
          'icon-container': {
            size: '{b_152}',
            'border-radius': '{b_153}'
          },
          icon: {
            size: '{b_154}'
          }
        },
        large: {
          container: {
            'border-radius': '{b_155}'
          },
          'inner-container': {
            'border-radius': '{b_155}',
            'padding-left': '{b_156}',
            'padding-right': '{b_156}',
            'padding-top': '{b_156}',
            'padding-bottom': '{b_156}'
          },
          'icon-container': {
            size: '{b_157}',
            'border-radius': '{b_158}'
          },
          icon: {
            size: '{b_159}'
          }
        },
        'xtra-large': {
          container: {
            'border-radius': '{b_160}'
          },
          'inner-container': {
            'border-radius': '{b_160}',
            'padding-left': '{b_161}',
            'padding-right': '{b_161}',
            'padding-top': '{b_161}',
            'padding-bottom': '{b_161}'
          },
          'icon-container': {
            size: '{b_162}',
            'border-radius': '{b_163}'
          },
          icon: {
            size: '{b_164}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'border-radius': '{b_165}'
          },
          'inner-container': {
            'border-radius': '{b_165}',
            'padding-left': '{b_166}',
            'padding-right': '{b_166}',
            'padding-top': '{b_166}',
            'padding-bottom': '{b_166}'
          },
          'icon-container': {
            size: '{b_167}',
            'border-radius': '{b_168}'
          },
          icon: {
            size: '{b_169}'
          }
        },
        'xtra-xtra-xtra-large': {
          container: {
            'border-radius': '{b_170}'
          },
          'inner-container': {
            'border-radius': '{b_170}',
            'padding-left': '{b_171}',
            'padding-right': '{b_171}',
            'padding-top': '{b_171}',
            'padding-bottom': '{b_171}'
          },
          'icon-container': {
            size: '{b_172}',
            'border-radius': '{b_173}'
          },
          icon: {
            size: '{b_174}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          container: {
            'border-radius': '{b_175}'
          },
          'inner-container': {
            'border-radius': '{b_175}',
            'padding-left': '{b_176}',
            'padding-right': '{b_176}',
            'padding-top': '{b_176}',
            'padding-bottom': '{b_176}'
          },
          'icon-container': {
            size: '{b_177}',
            'border-radius': '{b_173}'
          },
          icon: {
            size: '{b_179}'
          }
        }
      },
      label: {
        'xtra-small': {
          'inner-container': {
            height: '{b_180}'
          }
        },
        small: {
          'inner-container': {
            height: '{b_181}'
          }
        },
        medium: {
          'inner-container': {
            height: '{b_182}'
          }
        },
        large: {
          'inner-container': {
            height: '{b_183}',
            'padding-left': '{b_184}'
          }
        },
        'xtra-large': {
          'inner-container': {
            height: '{b_185}',
            'padding-left': '{b_186}'
          }
        },
        'xtra-xtra-large': {
          'inner-container': {
            height: '{b_187}'
          }
        },
        'xtra-xtra-xtra-large': {
          'inner-container': {
            height: '{b_188}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          'inner-container': {
            height: '{b_189}',
            'padding-left': '{b_190}'
          }
        }
      },
      'label-icon': {
        'xtra-small': {
          'inner-container': {
            height: '{b_201}'
          }
        },
        small: {
          'inner-container': {
            height: '{b_201}'
          }
        },
        medium: {
          'inner-container': {
            height: '{b_201}'
          }
        },
        large: {
          'inner-container': {
            height: '{b_202}'
          }
        },
        'xtra-large': {
          'inner-container': {
            height: '{b_203}'
          }
        },
        'xtra-xtra-large': {
          'inner-container': {
            height: '{b_204}'
          }
        },
        'xtra-xtra-xtra-large': {
          'inner-container': {
            height: '{b_205}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          'inner-container': {
            height: '{b_206}'
          }
        }
      },
      'label-image': {
        'xtra-small': {
          'inner-container': {
            height: '{b_201}'
          }
        },
        small: {
          'inner-container': {
            height: '{b_201}'
          }
        },
        medium: {
          'inner-container': {
            height: '{b_201}'
          }
        },
        large: {
          'inner-container': {
            height: '{b_202}'
          }
        },
        'xtra-large': {
          'inner-container': {
            height: '{b_203}'
          }
        },
        'xtra-xtra-large': {
          'inner-container': {
            height: '{b_204}'
          }
        },
        'xtra-xtra-xtra-large': {
          'inner-container': {
            height: '{b_205}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          'inner-container': {
            height: '{b_206}'
          }
        }
      }
    },
    {
      subtle: {
        default: {
          'inner-container': {
            'background-color': '{b_207}'
          },
          'icon-container': {
            'background-color': '{b_208}'
          },
          icon: {
            color: '{b_209}'
          },
          'label-jds-text': {
            color: '{text_41}'
          }
        },
        secondary: {
          'inner-container': {
            'background-color': '{b_267}'
          },
          'icon-container': {
            'background-color': '{b_268}'
          },
          icon: {
            color: '{b_269}'
          },
          'label-jds-text': {
            color: '{text_27}'
          }
        },
        positive: {
          'inner-container': {
            'background-color': '{b_210}'
          },
          'icon-container': {
            'background-color': '{b_211}'
          },
          icon: {
            color: '{b_212}'
          },
          'label-jds-text': {
            color: '{text_60}'
          }
        },
        warning: {
          'inner-container': {
            'background-color': '{b_213}'
          },
          'icon-container': {
            'background-color': '{b_214}'
          },
          icon: {
            color: '{b_215}'
          },
          'label-jds-text': {
            color: '{text_57}'
          }
        },
        negative: {
          'inner-container': {
            'background-color': '{b_216}'
          },
          'icon-container': {
            'background-color': '{b_217}'
          },
          icon: {
            color: '{b_218}'
          },
          'label-jds-text': {
            color: '{text_54}'
          }
        },
        neutral: {
          'inner-container': {
            'background-color': '{b_219}'
          },
          'icon-container': {
            'background-color': '{b_220}'
          },
          icon: {
            color: '{b_221}'
          },
          'label-jds-text': {
            color: '{text_21}'
          }
        }
      }
    },
    {
      icon: {
        bold: {
          default: {
            'inner-container': {
              'background-color': '{b_222}'
            },
            'icon-container': {
              'background-color': '{b_223}'
            },
            icon: {
              color: '{b_224}'
            }
          },
          secondary: {
            'inner-container': {
              'background-color': '{b_264}'
            },
            'icon-container': {
              'background-color': '{b_265}'
            },
            icon: {
              color: '{b_266}'
            }
          },
          positive: {
            'inner-container': {
              'background-color': '{b_225}'
            },
            'icon-container': {
              'background-color': '{b_226}'
            },
            icon: {
              color: '{b_227}'
            }
          },
          warning: {
            'inner-container': {
              'background-color': '{b_228}'
            },
            'icon-container': {
              'background-color': '{b_229}'
            },
            icon: {
              color: '{b_230}'
            }
          },
          negative: {
            'inner-container': {
              'background-color': '{b_231}'
            },
            'icon-container': {
              'background-color': '{b_232}'
            },
            icon: {
              color: '{b_233}'
            }
          },
          neutral: {
            'inner-container': {
              'background-color': '{b_234}'
            },
            'icon-container': {
              'background-color': '{b_235}'
            },
            icon: {
              color: '{b_236}'
            }
          }
        },
        subtle: {
          default: {
            'inner-container': {
              'background-color': '{b_237}'
            },
            'icon-container': {
              'background-color': '{b_238}'
            },
            icon: {
              color: '{b_239}'
            }
          },
          secondary: {
            'inner-container': {
              'background-color': '{b_261}'
            },
            'icon-container': {
              'background-color': '{b_262}'
            },
            icon: {
              color: '{b_263}'
            }
          },
          positive: {
            'inner-container': {
              'background-color': '{b_240}'
            },
            'icon-container': {
              'background-color': '{b_241}'
            },
            icon: {
              color: '{b_242}'
            }
          },
          warning: {
            'inner-container': {
              'background-color': '{b_243}'
            },
            'icon-container': {
              'background-color': '{b_244}'
            },
            icon: {
              color: '{b_245}'
            }
          },
          negative: {
            'inner-container': {
              'background-color': '{b_246}'
            },
            'icon-container': {
              'background-color': '{b_247}'
            },
            icon: {
              color: '{b_248}'
            }
          },
          neutral: {
            'inner-container': {
              'background-color': '{b_249}'
            },
            'icon-container': {
              'background-color': '{b_250}'
            },
            icon: {
              color: '{b_251}'
            }
          }
        }
      }
    },
    {
      true: {
        'xtra-small': {
          container: {
            'padding-left': '{b_252}',
            'padding-right': '{b_252}',
            'padding-top': '{b_252}',
            'padding-bottom': '{b_252}'
          }
        },
        small: {
          container: {
            'padding-left': '{b_253}',
            'padding-right': '{b_253}',
            'padding-top': '{b_253}',
            'padding-bottom': '{b_253}'
          }
        },
        medium: {
          container: {
            'padding-left': '{b_254}',
            'padding-right': '{b_254}',
            'padding-top': '{b_254}',
            'padding-bottom': '{b_254}'
          }
        },
        large: {
          container: {
            'padding-left': '{b_255}',
            'padding-right': '{b_255}',
            'padding-top': '{b_255}',
            'padding-bottom': '{b_255}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'padding-left': '{b_256}',
            'padding-right': '{b_256}',
            'padding-top': '{b_256}',
            'padding-bottom': '{b_256}'
          }
        },
        'xtra-xtra-xtra-large': {
          container: {
            'padding-left': '{b_257}',
            'padding-right': '{b_257}',
            'padding-top': '{b_257}',
            'padding-bottom': '{b_257}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          container: {
            'padding-left': '{b_258}',
            'padding-right': '{b_258}',
            'padding-top': '{b_258}',
            'padding-bottom': '{b_258}'
          }
        }
      }
    },
    {
      true: {
        icon: {
          container: {
            'background-color': '{b_270}',
            'padding-top': '{b_271}',
            'padding-bottom': '{b_271}',
            'padding-left': '{b_271}',
            'padding-right': '{b_271}'
          }
        }
      }
    },
    {
      true: {
        'icon-circle': {
          large: {
            container: {
              'padding-left': '{b_259}',
              'padding-right': '{b_259}',
              'padding-top': '{b_259}',
              'padding-bottom': '{b_259}'
            }
          }
        },
        'icon-square': {
          large: {
            container: {
              'padding-left': '{b_260}',
              'padding-right': '{b_260}',
              'padding-top': '{b_260}',
              'padding-bottom': '{b_260}'
            }
          }
        }
      }
    }
  ],
  combination_config: [
    ['kind', 'size'],
    ['appearance', 'color'],
    ['kind', 'appearance', 'color'],
    ['border', 'size'],
    ['border', 'kind'],
    ['border', 'kind', 'size']
  ],
  api: {
    config: {
      kind: {
        values: [
          'label-icon',
          'label-image',
          'label',
          'icon',
          'icon-circle',
          'icon-square'
        ]
      },
      size: {
        values: [
          'xtra-large',
          'small',
          'xtra-small',
          'medium',
          'large',
          'xtra-xtra-large',
          'xtra-xtra-xtra-large',
          'xtra-xtra-xtra-xtra-large'
        ]
      },
      color: {
        values: [
          'default',
          'secondary',
          'positive',
          'warning',
          'negative',
          'neutral'
        ]
      },
      appearance: {
        values: ['bold', 'subtle']
      },
      border: {
        values: [false, true]
      }
    },
    data: {
      jds_image: {
        src: {
          type: 'image',
          name: 'image'
        }
      },
      icon: {
        value: {
          type: 'icon',
          name: 'icon'
        }
      },
      'inner-container': {
        'background-color': {
          type: 'color',
          name: 'background'
        }
      },
      'icon-container': {
        'background-color': {
          type: 'color',
          name: 'background'
        }
      },
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
